// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cZ","reportCardBox":"cZ","report-img-wrap":"c0","reportImgWrap":"c0","report-title":"c1","reportTitle":"c1","report-date":"c2","reportDate":"c2"};